var ButtonLooks;
(function (ButtonLooks) {
  ButtonLooks["Danger"] = 'danger';
  ButtonLooks["Default"] = 'default';
  ButtonLooks["Primary"] = 'primary';
  ButtonLooks["Secondary"] = 'secondary';
  ButtonLooks["Tertiary"] = 'tertiary';
  ButtonLooks["TextSecondary"] = 'text-secondary';
  ButtonLooks["TextTertiary"] = 'text-tertiary';
  ButtonLooks["TextWarning"] = 'text-warning';
  ButtonLooks["Warning"] = 'warning';
  ButtonLooks["White"] = 'white';
})(ButtonLooks || (ButtonLooks = {}));
var ButtonSizes;
(function (ButtonSizes) {
  ButtonSizes[/** 225px */"Large"] = 'large';
  ButtonSizes[/** 175px */"Medium"] = 'medium';
  ButtonSizes[/** 125px */"Small"] = 'small';
  ButtonSizes[/** 75px */"XSmall"] = 'xsmall';
})(ButtonSizes || (ButtonSizes = {}));
var ButtonVariants;
(function (ButtonVariants) {
  ButtonVariants["Icon"] = 'icon';
  ButtonVariants["None"] = '';
  ButtonVariants["Standard"] = 'standard';
  ButtonVariants["Tile"] = 'tile';
})(ButtonVariants || (ButtonVariants = {}));
export { ButtonLooks, ButtonSizes, ButtonVariants };